import { addMinutes, isBefore } from "date-fns";
import { now } from "./now";
import { parseDate } from "./parseDate";

import { DentistNotification } from "@/data/DentistNotifications";
import {
  REQUEST_EXPIRATION_BUFFER_IN_MINUTES,
  REQUEST_STATUS_OPTIONS,
} from "@/utils/constants";

/**
 * Filters out expired request notifications from a list of notifications.
 * A notification is considered expired if it has a pending request that starts before the expiration time.
 * The expiration time is calculated as current time + REQUEST_EXPIRATION_BUFFER_IN_MINUTES.
 *
 * @param notifications - Array of dentist notifications to filter
 * @returns Array of valid (non-expired) notifications
 */
export const filterValidNotifications = (
  notifications: DentistNotification[],
): DentistNotification[] => {
  const expirationTime = addMinutes(
    now(),
    REQUEST_EXPIRATION_BUFFER_IN_MINUTES,
  );

  return notifications.filter((notification) => {
    const request = notification.request;

    // If there's no request, the notification is always valid
    if (!request) return true;

    const requestStartTime = parseDate(`${request.date}T${request.start_time}`);

    const isRequestExpired = isBefore(requestStartTime, expirationTime) &&
      request.status === REQUEST_STATUS_OPTIONS.PENDING;

    return !isRequestExpired;
  });
};
